'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var typescriptCookie = require('../../../node_modules/typescript-cookie/dist/typescript-cookie.mjs.js');
var jwtDecode_esm = require('../../../node_modules/jwt-decode/build/jwt-decode.esm.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LifepalContext = React.createContext({});
var setToken = function (token) {
    typescriptCookie.setCookie('token', token);
};
var removeToken = function () {
    typescriptCookie.removeCookie('token');
};
var getToken = function () {
    return typescriptCookie.getCookie('token');
};
var getUser = function () {
    var token = getToken();
    return jwtDecode_esm['default'](token);
};
var validateToken = function (token) {
    if (token && token.length > 0) {
        return true;
    }
    return false;
};
/* ALIASES */
var removeLoginData = function () {
    removeToken();
    localStorage.removeItem('digitalProductData');
    localStorage.removeItem('specification');
    localStorage.removeItem('orderId');
    localStorage.removeItem('plan');
    localStorage.removeItem('queueId');
    localStorage.removeItem('currentStep');
    localStorage.removeItem('isUserReadInstructions');
    localStorage.removeItem('superVisorPusherClient');
    localStorage.removeItem('statusList');
    localStorage.removeItem('quote');
    localStorage.removeItem('members');
    localStorage.removeItem('isNewLeadAssigned');
    localStorage.removeItem('leadList');
    localStorage.removeItem('expandedLead');
    localStorage.removeItem('isAutoStarted');
};
var getUserToken = getToken;
var LifepalProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(false), isAuthenticated = _b[0], setAuthenticated = _b[1];
    var _c = React.useState(true), isLoading = _c[0], setLoading = _c[1];
    var initializeAuth = function () {
        setLoading(true);
        var token = getUserToken();
        if (token && validateToken(token)) {
            setAuthenticated(true);
        }
        setLoading(false);
    };
    React.useEffect(function () {
        initializeAuth();
    }, []);
    return (React__default['default'].createElement(LifepalContext.Provider, { value: {
            setToken: setToken,
            getToken: getToken,
            removeToken: removeToken,
            getUser: getUser,
            isAuthenticated: isAuthenticated,
            isLoading: isLoading,
        } }, children));
};
var useLifepalContext = function () { return React.useContext(LifepalContext); };

exports.LifepalProvider = LifepalProvider;
exports.getUserToken = getUserToken;
exports.removeLoginData = removeLoginData;
exports.useLifepalContext = useLifepalContext;
//# sourceMappingURL=LifepalProvider.js.map
